<!--
 * @Description: 短信账单
 * @Version: 1.0
 * @Autor: zhaoyy
 * @Date: 2022-08-25 16:52:23
 * @LastEditors: zhaoyy
 * @LastEditTime: 2022-09-20 18:20:05
-->
<template>
  <div class="message-bill">
    <div class="templat-list">
      <div class="search-form">
        <el-form size="small" v-model="searchForm">
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item>
                <el-date-picker
                  v-model="searchDates"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="effectTimeListOptions">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <el-button type="primary" @click="searchFun">查询</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="statistical-data">
        <div class="statistical-data-title">
          <span class="statistical-data-title__left"></span>
          <span>统计数据</span>
        </div>
        <div class="statistical-data-content">
          <div class="statistical-data-content__item">
            <div class="item-title">发送成功总量</div>
            <div class="item-content">
              <span class="number">{{form.successCount}}</span>
              <span class="unit">次</span>
            </div>
          </div>
          <div class="statistical-data-content__item">
            <div class="item-title">发送失败总量</div>
            <div class="item-content">
              <span class="number">{{form.failedCount}}</span>
              <span class="unit">次</span>
            </div>
          </div>
          <div class="statistical-data-content__item">
            <div class="item-title">处理中</div>
            <div class="item-content">
              <span class="number">{{form.processingCount}}</span>
              <span class="unit">次</span>
            </div>
          </div>
          <div class="statistical-data-content__item">
            <div class="item-title">发送总量</div>
            <div class="item-content">
              <span class="number">{{form.totalCount}}</span>
              <span class="unit">次</span>
            </div>
          </div>
          <div class="statistical-data-content__item">
            <div class="item-title">计费短信总量</div>
            <div class="item-content">
              <span class="number">{{form.totalFeeNum}}</span>
              <span class="unit">条</span>
            </div>
          </div>
        </div>
      </div>
      <div class="table">
        <el-table ref="table" width="100%" :data="tableList" border stripe size="small" :max-height="newTableHeight">
          <el-table-column label="序号" type="index" width="60"></el-table-column>
          <el-table-column label="发送日期" prop="sendTime"></el-table-column>
          <el-table-column label="发送成功总量" prop="successCount"></el-table-column>
          <el-table-column label="发送失败总量" prop="failedCount"></el-table-column>
          <el-table-column label="处理中" prop="processingCount"></el-table-column>
          <el-table-column label="发送总量" prop="totalCount"></el-table-column>
          <el-table-column label="计费短信总量" prop="totalFeeNum"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { RESPONSE_SUCCESS } from '@/constants'
import debounce from 'lodash/debounce'
const currentMonths = function() {
  const date = new Date()
  const YYYY = date.getFullYear()
  const MM = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
  const DD = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
  return [`${YYYY}-${MM}-01`, `${YYYY}-${MM}-${DD}`]
}
export default {
  name: 'MessageBill',
  data() {
    return {
      searchForm: {},
      tableList: [],
      // 状态枚举
      statusList: {
        '1': '成功',
        '2': '失败'
      },
      newTableHeight: 0,
      tableWidth: 0,
      searchDates: currentMonths(),
      form: {},
      effectTimeListOptions: {
        disabledDate: time => {
          const maxTime = new Date(new Date(new Date().toLocaleDateString()).getTime())
          const minTime = new Date(new Date(new Date().toLocaleDateString()).getTime() - 364 * 24 * 3600 * 1000)
          return time.getTime() < minTime || time.getTime() > maxTime
        }
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      this.tableWidth = '100%'
    })
    this.searchFun()
    this.$nextTick(() => {
      setTimeout(() => {
        this.setTableHeight()
        this.tableWidth = '100%'
        // 绑定窗口resize事件 计算table高度
        this.resizeCallback = debounce(this.setTableHeight, 400)
        window.addEventListener('resize', this.resizeCallback, false)
      }, 300)
    })
  },
  methods: {
    dayjs(value) {
      if (value) {
        const date = new Date(value)
        const yyyy = date.getFullYear()
        const MM = date.getMonth() + 1
        const DD = date.getDate()
        return `${yyyy}-${MM > 9 ? MM : '0' + MM}-${DD > 9 ? DD : '0' + DD}`
      }
      return ''
    },
    getClientHeight() {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    },
    setTableHeight() {
      const table = this.$refs.table
      if (table) {
        const clientHeight = this.getClientHeight()
        this.newTableHeight = clientHeight - 400
      }
    },
    async searchFun() {
      const [ startTime = '', endTime = '' ] = this.searchDates
      const params = {
        startTime: this.dayjs(startTime) ? this.dayjs(startTime) + ' 00:00:00' : '',
        endTime: this.dayjs(endTime) ? this.dayjs(endTime) + ' 23:59:59' : ''
      }
      if (startTime && endTime) {
        const start = new Date(params.startTime).getTime()
        const end = new Date(params.endTime).getTime()
        const space = 3600 * 1000 * 24 * 31
        if (end - start > space) {
          this.$message.warning('最多可查询31天内的账单，请重新选择')
          return
        }
      }

      const { data, msg, code } = await this.$API.statisticsQuery(params)
      if (code === RESPONSE_SUCCESS) {
        this.form = data
        this.tableList = data.perDayDataList
      } else {
        this.$message.warning(msg)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.statistical-data {
  &-title {
    display: flex;
    align-items: center;
    &__left {
      width: 3px;
      height: 18px;
      background: #e60000;
      display: inline-block;
      margin-right: 6px;
    }
  }
  &-content {
    display: flex;
    margin: 10px 0;
    width: 878px;
    &__item {
      width: 150px;
      height: 100px;
      background: #f4f4f4;
      border: 1px solid #ddd;
      border-right: none;
      text-align: center;
      &:last-child {
        border-right: 1px solid #ddd;
      }
      .item-title {
        font-size: 12px;
        text-align: center;
        margin-top: 25px;
      }
      .item-content {
        margin-top: 10px;
        .number {
          font-size: 18px;
        }
        .unit {
          font-size: 14px;
        }
      }
    }
  }
}
.el-input {
  width: 100% !important;
}
.add-button ::v-deep .el-form-item__content {
  text-align: right !important;
}
.table{
  height: calc(100vh - 500px);
}
.point::after {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 6px;
  display: inline-block;
  margin-right: 6px;
}
.warning::after {
  background: #E6A23C;
}
.danger::after {
  background: #F56C6C;
}
.success::after {
  background: #67C23A;
}
</style>
